/**
 * Clipboard utility functions
 */

/**
 * Copy text to clipboard
 */
export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
};

/**
 * Copy text to clipboard with alert notification
 */
export const copyWithAlert = async (
  text: string,
  options: {
    successMessage?: string;
    fallbackMessage?: string;
    includeClipboardStatus?: boolean;
  } = {}
): Promise<void> => {
  const {
    successMessage = '복사되었습니다',
    fallbackMessage = '복사할 내용',
    includeClipboardStatus = true,
  } = options;

  const copied = await copyToClipboard(text);

  if (copied && includeClipboardStatus) {
    alert(`${successMessage}\n\n✅ 클립보드에 복사되었습니다!`);
  } else if (copied) {
    alert(successMessage);
  } else if (includeClipboardStatus) {
    alert(`${fallbackMessage}\n\n⚠️ 클립보드 복사에 실패했습니다.`);
  } else {
    alert(fallbackMessage);
  }
};

/**
 * Copy temporary password with formatted alert
 */
export const copyTemporaryPassword = async (
  password: string,
  studentName: string,
  userId?: string
): Promise<void> => {
  const copied = await copyToClipboard(password);

  const userIdInfo = userId ? `\n• 사용자 ID: ${userId}` : '';
  const baseMessage = `수업 신청이 승인되었습니다!\n\n회원 정보:\n• 이름: ${studentName}${userIdInfo}\n• 임시 비밀번호: ${password}`;

  if (copied) {
    alert(`${baseMessage}\n\n✅ 임시 비밀번호가 클립보드에 복사되었습니다!\n⚠️ 학생에게 임시 비밀번호를 전달하고 로그인 후 비밀번호 변경을 안내해주세요.`);
  } else {
    alert(`${baseMessage}\n\n⚠️ 학생에게 임시 비밀번호를 전달하고 로그인 후 비밀번호 변경을 안내해주세요.`);
  }
};
